import { render, staticRenderFns } from "./formActivation.vue?vue&type=template&id=48052c92&scoped=true"
import script from "./formActivation.vue?vue&type=script&lang=js"
export * from "./formActivation.vue?vue&type=script&lang=js"
import style0 from "./formActivation.vue?vue&type=style&index=0&id=48052c92&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48052c92",
  null
  
)

export default component.exports